<template>
  <div>
    <div class="header mb-20" @click="back">
      <i class="el-icon-back" /> | 详情
    </div>
    <!-- 广告start -->
    <el-card class="custom-card mb-20" shadow="never">
      <div slot="header" class="custom-card-header flex">
        <h1>广告</h1>
        <el-button
          style="margin-left: auto"
          round
          type="danger"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd()"
        >添加</el-button
        >
      </div>
      <el-table :data="tableData" fit style="width: 100%">
        <el-table-column label="广告名称" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.AdvInfo.AdvName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="广告资源" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.AdvInfo.AdvOssUrl }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="播放时长(秒)" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.AdvInfo.PlayDuration }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <!-- <el-link type="primary" @click="handleAdd(row)">编辑</el-link> -->
            <el-link type="danger" @click="delAdv(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-card class="custom-card" shadow="never">
        <el-pagination
          v-show="total > 0"
          :current-page="listQuery.pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="listQuery.pageSize"
          :total="total"
          layout="total, prev, pager, next"
          @size-change="handleSizeChange($event, 'listQuery')"
          @current-change="handleCurrentChange($event, 'listQuery')"
        />
      </el-card>
    </el-card>
    <dialog-custom
      :centerDialogVisible="advVisible"
      title="添加/编辑投放计划"
      @handleCancel="handleCancel"
      @handleConfirm="handleConfirm('dataForm')"
    >
      <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="advRules"
        label-width="100px"
        class="demo-dataForm"
      >
        <el-form-item label="广告" prop="AdvId">
          <el-select v-model="dataForm.AdvId" style="width: 100%" placeholder="请选择广告">
            <el-option
              v-for="item in advArr"
              :key="item.AdvId"
              :value="item.AdvId"
              :label="item.AdvName"
            >
              {{ item.AdvName }}
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </dialog-custom>
    <!-- 广告end -->

    <!-- 设备start -->
    <el-card class="custom-card" shadow="never">
      <div slot="header" class="custom-card-header flex">
        <h1>设备</h1>
        <el-button
          style="margin-left: auto"
          round
          type="danger"
          icon="el-icon-circle-plus-outline"
          @click="handleAddDevice()"
        >添加</el-button
        >
      </div>
      <el-table :data="deviceTableData" fit style="width: 100%">
        <el-table-column label="设备编号" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.DeviceInfo.Identity }}</span>
          </template>
        </el-table-column>
        <el-table-column label="设备名称" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.DeviceInfo.Name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="在线状态" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.DeviceInfo.StatusNo | filterStatusNo }}</span>
          </template>
        </el-table-column>
        <el-table-column label="场地名称" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.FieldName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="播放总次数" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.DeviceAdvGroupInfo.TotalPlayCount }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="播放总时长(秒)" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.DeviceAdvGroupInfo.TotalPlayDuration }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center">
          <template slot-scope="{ row }">
            <el-link type="primary" @click="playHistory(row)">播放记录</el-link>
            <el-link type="danger" @click="delDevice(row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <el-card class="custom-card" shadow="never">
        <el-pagination
          v-show="deviceTotal > 0"
          :current-page="deviceListQuery.pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="deviceListQuery.pageSize"
          :total="deviceTotal"
          layout="total, prev, pager, next"
          @size-change="handleSizeChange($event, 'deviceListQuery')"
          @current-change="handleCurrentChange($event, 'deviceListQuery')"
        />
      </el-card>
    </el-card>
    <dialog-custom
      :centerDialogVisible="deviceVisible"
      title="添加/编辑设备"
      @handleCancel="handleCancel"
      @handleConfirm="hanldeDeviceConfirm('deivceDataForm')"
    >
      <el-form
        ref="deivceDataForm"
        :model="deivceDataForm"
        :rules="advRules"
        label-width="100px"
        class="demo-dataForm"
      >
        <el-form-item label="设备" prop="DeviceIds">
          <el-select v-model="deivceDataForm.DeviceIds" multiple style="width: 100%" placeholder="请选择设备">
            <el-option
              v-for="item in deviceArr"
              :key="item.DeviceInfo.DId"
              :value="item.DeviceInfo.DId"
              :label="item.DeviceInfo.Identity+item.DeviceInfo.Name+'-'+(item.DeviceInfo.StatusNo === 'A'?'在线': '离线')"
            >
              {{ item.DeviceInfo.Identity }}-{{ item.DeviceInfo.Name }}-{{ item.DeviceInfo.StatusNo | filterStatusNo }}
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </dialog-custom>
    <dialog-custom
      :centerDialogVisible="playVisible"
      :footer="false"
      screenWidth="60%"
      title="播放记录"
      @handleCancel="handleCancel"
    >
      <el-table :data="playTableData" fit style="width: 100%">
        <el-table-column label="设备编号" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.DeviceInfo.Identity }}</span>
          </template>
        </el-table-column>
        <el-table-column label="设备名称" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.DeviceInfo.Name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="场地名称" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.FieldName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="播放次数" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.AdvPlayHistory.PlayCount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="播放时长(秒)" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.AdvPlayHistory.PlayDuration }}</span>
          </template>
        </el-table-column>
        <el-table-column label="播放时间" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.AdvPlayHistory.UploadTime | filterTime }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-card class="custom-card" shadow="never">
        <el-pagination
          v-show="playTotal > 0"
          :current-page="playListQuery.pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="playListQuery.pageSize"
          :total="playTotal"
          layout="total, prev, pager, next"
          @size-change="handleSizeChange($event, 'playListQuery')"
          @current-change="handleCurrentChange($event, 'playListQuery')"
        />
      </el-card>
    </dialog-custom>
    <!-- 设备end -->
  </div>
</template>
<script>
import moment from 'moment'
import DialogCustom from '@/components/DialogCustom'
import {
  qryAdvGroupInfo,
  qryAdvInfo,
  addAdvGroupInfo,
  modAdvGroupInfo,
  delAdvGroupInfo,
  qryDeviceGroupInfo,
  qryDeviceInfo,
  batchAddDeviceGroupInfo,
  delDeviceGroupInfo,
  qryAdvPlayHistory
} from '@/api/adv'
export default {
  // 组件名称
  name: 'PlanAdv',
  // 过滤器
  filters: {
    filterTime(value) {
      return value ? moment(value).format('YYYY-MM-DD HH') + '点' : ''
    },
    filterStatusNo(value) {
      let str = ''
      switch (value) {
        case 'A':
          str = '在线'
          break

        default:
          str = '离线'
          break
      }
      return str
    }
  },
  // 组件
  components: {
    DialogCustom
  },
  // props类型
  props: {
    detail: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  // 数据
  data() {
    return {
      // 设备部分
      playTotal: 0,
      playTableData: [],
      playListQuery: {
        deviceId: null,
        groupId: null,
        pageIndex: 1,
        pageSize: 10
      },
      playVisible: false,
      deviceArr: [],
      deivceDataForm: {
        GroupId: null,
        DeviceIds: []
      },
      deviceVisible: false,
      deviceListQuery: {
        groupId: null,
        pageIndex: 1,
        pageSize: 10
      },
      deviceTableData: [],
      deviceTotal: 0,
      // 广告部分
      advVisible: false,
      tableData: [],
      listQuery: {
        groupId: null,
        pageIndex: 1,
        pageSize: 10
      },
      dataForm: {
        AdvGroupId: 0,
        GroupId: null,
        AdvId: null
      },
      advArr: [],
      advRules: {
        AdvId: [{ required: true, message: '请选择广告', trigger: 'blur' }],
        DeviceIds: [
          { required: true, message: '请选择设备', trigger: 'blur' }
        ]
      },
      total: 0
    }
  },
  // 计算属性
  computed: {},
  // 计算属性监听
  watch: {},
  // 创建时
  created() {
    this.playListQuery.groupId = this.deivceDataForm.GroupId = this.deviceListQuery.groupId = this.dataForm.GroupId = this.listQuery.groupId = this.detail.GroupInfo.GroupId
    this.getList()
    this.getAdvList()
    this.getDeivceList()
  },
  // 挂载完毕
  mounted() {},
  // 方法
  methods: {
    // 播放记录
    playHistory(row) {
      this.playListQuery.deviceId = row.DeviceInfo.DId
      qryAdvPlayHistory(this.playListQuery).then(res => {
        this.playTableData = res.LsList
        this.playTotal = res.TotalRows
      })
      this.playVisible = true
    },
    delDevice(row) {
      delDeviceGroupInfo({ Id: row.DeviceAdvGroupInfo.DeviceAdvGroupId }).then(res => {
        this.$message.success('删除成功')
        this.getDeivceList()
      })
    },
    hanldeDeviceConfirm(dataForm) {
      console.log(this.deivceDataForm)
      this.$refs[dataForm].validate(valid => {
        if (valid) {
          batchAddDeviceGroupInfo(this.deivceDataForm).then(res => {
            this.$message.success('添加成功')
            this.handleCancel()
            this.getDeivceList()
          })
        }
      })
    },
    handleAddDevice() {
      qryDeviceInfo({ notInGroupId: this.detail.GroupInfo.GroupId, pageIndex: 1, pageSize: 2 ** 31 - 1 }).then(res => {
        this.deviceArr = res.LsList
      })
      this.deviceVisible = true
    },
    getDeivceList() {
      qryDeviceGroupInfo(this.deviceListQuery).then((res) => {
        this.deviceTableData = res.LsList
        this.deviceTotal = res.TotalRows
      })
    },
    // 删除广告
    delAdv(row) {
      delAdvGroupInfo({ Id: row.AdvGroupId }).then((res) => {
        this.$message.success('删除成功')
        this.getList()
      })
    },
    // 确定广告弹窗
    handleConfirm(dataForm) {
      this.$refs[dataForm].validate((valid) => {
        if (valid) {
          if (this.dataForm.AdvGroupId) {
            modAdvGroupInfo(this.dataForm).then((res) => {
              this.$message.success('修改成功')
              this.handleCancel()
              this.getList()
            })
          } else {
            addAdvGroupInfo(this.dataForm).then((res) => {
              this.$message.success('添加成功')
              this.handleCancel()
              this.getList()
            })
          }
        }
      })
    },
    // 取消弹窗
    handleCancel() {
      this.dataForm = {
        AdvGroupId: 0,
        GroupId: this.detail.GroupInfo.GroupId,
        AdvId: null
      }
      this.deivceDataForm = {
        GroupId: this.detail.GroupInfo.GroupId,
        DeviceIds: []
      }
      this.advVisible = false
      this.deviceVisible = false
      this.playVisible = false
    },
    async handleAdd(row) {
      await this.getAdvList()
      if (row) {
        this.dataForm.AdvGroupId = row.AdvGroupId
      }
      this.advVisible = true
    },
    // 获取广告资源
    getAdvList() {
      qryAdvInfo({
        notInGroupId: this.dataForm.GroupId,
        pageIndex: 1,
        pageSize: 2 ** 31 - 1
      }).then((res) => {
        this.advArr = res.LsList
      })
    },
    // 获取广告列表
    getList() {
      qryAdvGroupInfo(this.listQuery).then((res) => {
        this.tableData = res.LsList
        this.total = res.TotalRows
      })
    },
    back() {
      this.$emit('back')
    },
    handleSizeChange(e, value) {
      this[value].pageSize = e
      this.getList()
    },
    handleCurrentChange(e, value) {
      this[value].pageIndex = e
      this.getList()
    }
  }
}
</script>

<style lang='less' scoped>
.custom-card {
  ::v-deep {
    .el-card__header {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}
.header {
  color: #409eff;
  cursor: pointer;
  font-size: 16px;
}
</style>
